import { render, staticRenderFns } from "./AliasMode.vue?vue&type=template&id=2b8bd914&"
import script from "./AliasMode.vue?vue&type=script&lang=js&"
export * from "./AliasMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports